"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const map = require(`../../../img/map-2x.png`);
const Wrapper = styled_components_1.default.div `
  display: none;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    display: block;
    position: absolute;
    right: -123;
    top: -20%;
  }

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    top: -25%;
  }

  ${ScreenSizes_1.DESKTOP} {
    right: -132;
    top: -40%;
  }
`;
const Img = styled_components_1.default.img `
  width: 520px;

  ${ScreenSizes_1.TABLET_LANDSCAPE} {
    width: 700px;
  }

  ${ScreenSizes_1.DESKTOP} {
    width: 938px;
  }
`;
exports.Map = () => {
    return (React.createElement(Wrapper, null,
        React.createElement(Img, { src: map })));
};



// WEBPACK FOOTER //
// ./src/components/styled/img/Map.tsx